




























import { Vue, Component, Prop } from 'vue-property-decorator'
import { isAphone } from '@/utils/mUtil'

@Component
export default class FormItem extends Vue {
  @Prop({ type: String, default: '' })
  title!: string

  @Prop({ type: Boolean, default: false })
  inputDisable!: boolean

  @Prop({ type: String, default: '' })
  placeholder!: string

  @Prop({ type: String, default: '' })
  value!: string

  @Prop({ type: Number, default: -1 })
  limit!: number

  @Prop({ type: Boolean, default: false })
  isRequired!: boolean

  @Prop({ type: String, default: '' })
  label!: string

  showErrorTip: boolean = false
  errorTip: string = ''

  onChange(e: any) {
    this.$emit('input', e.target.value)
    if (e.target.value === '') {
      this.showErrorTip = true
      this.errorTip = '请输入' + this.title
    } else {
      this.errorTip = ''
    }
  }

  blurNameFun(e: any) {
    console.log('blurNameFun')
    if (e.target.value === '') {
      this.showErrorTip = true
      this.errorTip = '请输入' + this.title
    } else {
      this.errorTip = ''
    }
  }

  handleFocus(e: any) {
    this.$emit('handleFocus')
    console.log('handleFocus')
  }
}
